var map = {
	"./acwa_power.png": "cbc1",
	"./bank_aljazira.png": "433d",
	"./best-analytics-measurement-impact-solution.png": "d1f5",
	"./best-analytics.png": "8f26",
	"./cambridge.svg": "13a6",
	"./cambridge_logo.png": "b53f",
	"./cambridge_logo.svg": "bf70",
	"./cambridge_psychometrics.png": "edaa",
	"./distell.png": "71d9",
	"./dussur.png": "7a94",
	"./famousbrands.png": "64da",
	"./fitt_dark.png": "98ab",
	"./fitt_dark_clear_cropped.png": "58d6",
	"./fitt_dark_clear_cropped_old.png": "9cc1",
	"./fitt_light.png": "fcd9",
	"./fitt_light_cropped.png": "4989",
	"./fitt_light_old.png": "0ea1",
	"./future-hr.png": "7d0f",
	"./ghc.png": "8431",
	"./kpmg.png": "6694",
	"./maaden.png": "8887",
	"./medihelp.png": "fcfd",
	"./meridian.png": "189f",
	"./pwc.png": "6f21",
	"./qafco.png": "363b",
	"./qatar.png": "4276",
	"./santam.png": "2239",
	"./sec.png": "0885",
	"./slg.png": "e8f8",
	"./stc.png": "a1db",
	"./the-future-hr-icon.png": "d1a9",
	"./winer-sustainability-icon.png": "5486",
	"./winner-tech-innovation-awards-icon.png": "6881",
	"./wood.png": "74fc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "22d1";